import Slot, {SLOT_PAYMENT_STATUS_PAID} from "../../../../entities/Slot";
import patch from "../../../patch";

export const appoint = (slot: Slot, text: string) =>
    patch(
      `slots/${slot.id}`,
      { state: SLOT_PAYMENT_STATUS_PAID, text: text }
    );